import useEnabledFeature from '../../useEnabledFeature/useEnabledFeature';

const useSwitchContract = (): boolean => {
  return useEnabledFeature('cat-switch-contract');
};

export default useSwitchContract;
